/**
 * This enum is used for getting user profile fields.
 */
export enum UserProfileFieldsEnum {
  EMAIL = 'email',
  NAME = 'name',
  CLIENT_ID = 'clientID',
  HG_CUSTOMER = 'hg-customer',
}
